import TextField from '@mui/material/TextField';
import { Controller } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import { handleMessageError } from '../../util/handleMessages';

export interface IFormInputProps {
    variant?: 'outlined' | 'standard' | 'filled' | undefined;
    name: string;
    control: any;
    rules?: any;
    label: string;
    messageError?: (errors: any, field: any) => string;
    handleChange?: any;
    handleOnKeyPress?: (data: any) => void;
    decimalScale: number;
    handleOnBlur?: any;
    autoFocus?: boolean;
    readOnly?: boolean;
    messagesError?: { type: string; message: string }[];
}

export const defaultValidation = (value: number) => {
    if (value && value < 0) {
        return 'O campo valor não pode ser menor que zero';
    }
    if (
        value &&
        !value.toString().includes('.') &&
        value.toString().length > 14
    ) {
        return 'O valor não pode ter mais que 14 dígitos';
    }
    if (value && value.toString().includes('.')) {
        const [number] = value.toString().split('.');
        if (number.length > 14) {
            return 'O valor não pode ter mais que 14 dígitos';
        }
    }
};

export const FormInputNumber = ({
    variant,
    name,
    control,
    rules,
    label,
    messageError,
    handleChange,
    handleOnKeyPress,
    decimalScale,
    handleOnBlur,
    autoFocus,
    readOnly,
    messagesError,
}: IFormInputProps) => {
    if (!variant) {
        variant = 'outlined';
    }

    let defaultRules = {
        validate: (value: number) => {
            return defaultValidation(value);
        },
    };

    if (rules) {
        defaultRules = rules;
    }

    return (
        <Controller
            name={name}
            control={control}
            rules={defaultRules}
            render={({
                field: { onChange, value },
                fieldState: { error },
                formState,
            }) => {
                return (
                    <NumberFormat
                        data-qa={name}
                        id={name}
                        customInput={TextField}
                        inputRef={(input: any) => {
                            input && autoFocus && input.focus();
                        }}
                        helperText={handleMessageError(
                            messageError,
                            messagesError,
                            error,
                            name,
                        )}
                        readOnly={readOnly}
                        // InputProps={{
                        //     readOnly: readOnly,
                        // }}
                        error={!!error}
                        variant={variant}
                        label={label}
                        size="small"
                        fullWidth
                        onKeyPress={(data: any) => {
                            handleOnKeyPress && handleOnKeyPress(data);
                        }}
                        onKeyUp={(event: any) => {
                            if (
                                event.target?.value === '0,00' &&
                                event.code === 'Backspace'
                            ) {
                                event.target.value = '';
                            }
                        }}
                        onValueChange={values => {
                            onChange(Number(values.value));
                            // const value = values.floatValue;

                            handleChange && handleChange(Number(values.value));
                        }}
                        autoComplete="off"
                        onBlur={(event: any) => {
                            handleOnBlur && handleOnBlur(event);
                        }}
                        decimalScale={decimalScale}
                        value={value}
                        decimalSeparator=","
                        displayType="input"
                        thousandSeparator="."
                        allowNegative={true}
                        fixedDecimalScale={true}
                    />
                );
            }}
        />
    );
};
